
import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';

import { PostulacionesSaludService } from '../../services/postulaciones-salud/postulaciones-salud.service';
import { ProductosService } from 'src/app/services/productos/productos.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import { DialogTipoRechazo } from '../common/postulacion-rechazar.component';
import { ReembolsosService } from 'src/app/services/reembolsos/reembolsos.service';
import { environment } from '../../../environments/environment';
import Swal from 'sweetalert2';


export interface DialogData
{
    archivo: any[]
    archivos: any
    archivoTest: any
    archivoTest2: any
    idPostulacion: any
    beneficiario: any
    tipoReembolso: any
    tiposReembolso: any
    reembolsoCategoria: any
    reembolsoSubcategoria: any
    prevision: any
    categorias: any
    subcategorias: []
    previsiones: []
    rutPrestador: any
    dvPrestador: any
    nDocumento: any
    nBoleta: any
    montoCopago: any
    montoReembolso: any
    folioExterno: any
    observacion: string
    tipoDocumento: any
    fechaDocumento: any
    carga: boolean
    postulantes: any
    deshabilitado: boolean
    presionaEditar: boolean
    recarga: boolean
    email: string
    nombreCompleto: string
    mostrarAprobarButton:any
    mostrarEnviarButton:any
    rol: string
    tiposDocumento: any
    mostrarEditar: any
    disponiblePago:any
    mostrarEditarButton: any
    mostrarRechazarButton: any
    diasDiferencia:any
    cantidadArchivos: any;
}

@Component({
    selector: 'dialog-overview-example-dialog',
    templateUrl: '../../pages/postulaciones-salud/postulacion-reembolso-validar.html',
    styleUrls: ['../../pages/postulaciones-salud/postulaciones-salud.component.css']
})
export class DialogEditPostulacionReembolso
{
    diasDiferencia1: any
    diaTerminoConvenio: any
    mesTerminoConvenio: any
    AnnioTerminoConvenio: any

    constructor( public dialogRef: MatDialogRef<DialogEditPostulacionReembolso>,
                 private postulacionesSaludService: PostulacionesSaludService,
                 @Inject(MAT_DIALOG_DATA) public data: DialogData, private dialog: MatDialog,
                 private reembolsosService: ReembolsosService,
                 private productosService: ProductosService)
    {
        this.data.recarga = false
        this.data.archivo = []
        this.data.rol = localStorage.getItem('rol')
        this.diasDiferencia1 = this.data.diasDiferencia
        this.data.cantidadArchivos = 1;
        let vm = this
        this.productosService.obtieneProductos().then
        (
            productos => productos[2].parametros.map( parametro => {
            
                if(parametro.descripcion == 'DIA_PRIMER_CONVENIO') {
                    vm.diaTerminoConvenio = parametro.valor
                }
                if(parametro.descripcion == 'MES_PRIMER_CONVENIO') {
                    vm.mesTerminoConvenio = parametro.valor
                }
                if(parametro.descripcion == 'ANNIO_PRIMER_CONVENIO') {
                    vm.AnnioTerminoConvenio = parametro.valor
                }			
            })
        )
        .catch ( error => console.log(error) )
      
    }

    onRechazarClick(idPostulacion: any): void
    {
        let vm = this
        let dataRechazo: any =
        {
            idPostulacion: idPostulacion,
            tiposRechazo: [],
            tipoRechazo: '',
            email:this.data.email,
            nombreCompleto: this.data.nombreCompleto,
            nombreProducto: 'REEMBOLSO'
        }

        this.postulacionesSaludService.motivoRechazo(3).then
        (
            rechazos => { dataRechazo.tiposRechazo = rechazos
              }
        )
        .catch ( error => {console.log(error)
      } )

        const dialogRechazo = this.dialog.open(DialogTipoRechazo, { width: '50%', data: dataRechazo })

        dialogRechazo.afterClosed().subscribe( () =>
        {
            vm.data.recarga = true
            vm.dialogRef.close()
        })
    }

    onAprobarClick(idPostulacion: any, idCarga: any,idUsuario:any): void
    {
        let vm = this
        let idUsuarioSesion = localStorage.getItem("idUsuario")
        const dialogRef = this.dialog.open(ConfirmationDialog,
        {
            data: { message: '¿Esta seguro de aprobar la postulación?', buttonText: { ok: 'Si', cancel: 'No' } }
        })

        dialogRef.afterClosed().subscribe((confirmed: boolean) =>
        {
            if (confirmed)
            {

              Swal.fire({
                allowOutsideClick:false,
                icon:'info',
                text:'Cargando...'
              });
              Swal.showLoading();
             vm.evaluaMontoReembolso();
             if(vm.data.montoCopago == 0){
                vm.openAlertDialog('El Monto Copago no debe ser 0 al aprobar el Reembolso', 'btn-danger')
                vm.dialogRef.close()
                Swal.close();
                return
            }
                vm.reembolsosService.traeMontoDisponibleSubCategoria(vm.data.beneficiario.id, !vm.data.carga,
                vm.data.reembolsoSubcategoria,vm.data.idPostulacion).then
                (
                    montoDisponible =>
                    {
                        console.log(montoDisponible)

                        if(montoDisponible == 0)
                        {
                            Swal.close();
                            vm.openAlertDialog('Usted ya utilizó el cupo anual que tiene asignado para este tipo de reembolso por lo que no puede ingresar solicitud.', 'btn-danger')
                            return
                        }
                        let fechaIngresada = new Date(this.data.fechaDocumento + 'T00:00')

                        let fechaMinima = new Date()
                        fechaMinima.setDate(fechaMinima.getDate() - this.diasDiferencia1)
                        if(fechaIngresada < fechaMinima || fechaIngresada > new Date())
                        {
                            this.openAlertDialog('La Fecha del Documento supera la vigencia de 180 dias o excede la fecha actual. Favor revisar.', 'btn-danger')
                            
                            Swal.close();
                            return
                        }

                          let fecha = vm.data.fechaDocumento.split('-')
                          let fechaFormateada = fecha[2] + '-' + fecha[1] + '-' + fecha[0]

                          let reembolso: any =
                          {
                            tipoReembolso: vm.data.tipoReembolso,
                            categoria: vm.data.reembolsoCategoria,
                            subcategoria: vm.data.reembolsoSubcategoria,
                            prevision: vm.data.prevision,
                            nDocumento: vm.data.nDocumento,
                            nBoleta: vm.data.nBoleta,
                            rutPrestador: vm.data.rutPrestador,
                            montoCopago: vm.data.montoCopago,
                            tipoDocumento: vm.data.tipoDocumento,
                            montoReembolso: Math.round(vm.data.montoReembolso),
                            fechaDocumento: fechaFormateada,
                            archivo:vm.data.archivo,
                            observacion:vm.data.observacion
                          }
                         
                          if(vm.data.montoReembolso > montoDisponible){
                              
                              this.data.montoReembolso =montoDisponible;
                              reembolso.montoReembolso= montoDisponible;
                              vm.data.montoReembolso = montoDisponible;
                           }
                            vm.postulacionesSaludService.editaPostulacionReembolso(idPostulacion, idCarga, reembolso,idUsuario).then
                              (
                                  () =>
                                  {
                                    console.log("actualizacion");
                                    vm.postulacionesSaludService.cambiarEstadoPostulacion(idPostulacion, "DISPONIBLE PARA PAGO",idUsuarioSesion
                                      ).then
                                        (
                                            () =>
                                            {
                                                vm.data.recarga = true
                                                vm.dialogRef.close()
                                                Swal.close();
                                                vm.openAlertDialog('La postulación se ha aprobado exitosamente.', 'btn-success')
                                            }
                                        )
                                        .catch
                                        (
                                            error =>
                                            {
                                                console.log(error)
                                                Swal.close();
                                                vm.dialogRef.close()
                                                vm.openAlertDialog('Ha ocurrido un error al guardar el Reembolso', 'btn-danger')
                                            }
                                        )
                                  }
                                )
                                  .catch
                                  (
                                    error =>
                                    {
                                      vm.dialogRef.close()
                                      console.log(error)

                                      if(error.status == 403)
                                      {
                                        Swal.close();
                                        vm.openAlertDialog('Ya se tiene ingresada una solicitud con el mismo N. Documento, Tipo de Documento y Rut de Prestador.', 'btn-danger')

                                        return
                                      }
                                      else {
                                        Swal.close();
                                        vm.openAlertDialog('Ha ocurrido un error al guardar el Reembolso.', 'btn-danger') }
                                    }
                                  )                        
                    }
                )
                .catch(error =>
                {
                    console.log(error)
                  
                    if(error.status != 404)
                    {
                        Swal.close();
                        vm.openAlertDialog('Usted ya utilizó el cupo anual que tiene asignado para este tipo de reembolso por lo que no puede ingresar solicitud.', 'btn-danger')
                        return
                    }
                    else{
                        Swal.close();
                        vm.openAlertDialog('Ha ocurrido un error interno.', 'btn-danger')
                        return
                    }
                  
                })
            }
        })
    }

    onEnviarClick(idPostulacion: any, idCarga: any,idUsuario:any): void
    {
        let vm = this
        let idUsuarioSesion = localStorage.getItem("idUsuario")

        let envioACompania=0;       
        var fechaDocumento = new Date(this.data.fechaDocumento.split('-')[0], this.data.fechaDocumento.split('-')[1], this.data.fechaDocumento.split('-')[2]);
        var fechaLimite = new Date(vm.AnnioTerminoConvenio, vm.mesTerminoConvenio, vm.diaTerminoConvenio);
     
        /*
        if(fechaDocumento > fechaLimite){
            console.log("ANTES FECHA LIMITE");
            envioACompania=1;
            this.openAlertDialog('La Fecha de Documento supera la fecha de corte con el proveedor externo.', 'btn-danger')
            Swal.close();
            return
        }*/
    
        if (fechaDocumento <= fechaLimite) {
            console.log("fechaLimite:", fechaLimite);
            console.log("ANTES FECHA LIMITE");
            envioACompania = 1;
        } else {
            console.log("DESPUES FECHA LIMITE");
            envioACompania = 2;
        }


      
        const dialogRef = this.dialog.open(ConfirmationDialog,
        {
            data: { message: '¿Esta seguro de enviar la postulación a la compañía?', buttonText: { ok: 'Si', cancel: 'No' } }
        })

        dialogRef.afterClosed().subscribe((confirmed: boolean) =>
        {
            if (confirmed)
            {

              Swal.fire({
                allowOutsideClick:false,
                icon:'info',
                text:'Cargando...'
              });
              Swal.showLoading();
              let fechaIngresada = new Date(this.data.fechaDocumento + 'T00:00')

                let fechaMinima = new Date()
                fechaMinima.setDate(fechaMinima.getDate() - this.diasDiferencia1)
                if(fechaIngresada < fechaMinima || fechaIngresada > new Date())
                {
                    this.openAlertDialog('La Fecha del Documento supera la vigencia de 180 dias o excede la fecha actual. Favor revisar.', 'btn-danger')
                    Swal.close();
                    return
                }
                if (envioACompania == 1) {    

                    vm.data.recarga = true
                    vm.dialogRef.close()
                    Swal.close();
                    vm.openAlertDialog('La solicitud no se puede enviar a BCI por plazo vencido.', 'btn-success')                                        
 
                /*   
                 vm.postulacionesSaludService.envioCompania(idPostulacion).then(
                            () =>{
                                vm.data.recarga = true
                                vm.dialogRef.close()
                                Swal.close();
                                vm.openAlertDialog('La postulación se ha enviado exitosamente a la compañía BCI.', 'btn-success')                                        
                      
                                vm.postulacionesSaludService.cambiarEstadoPostulacion(idPostulacion, "ENVIADO A COMPANIA",idUsuarioSesion).then                 (
                                    () =>
                                    { 
                                        vm.data.recarga = true
                                        vm.dialogRef.close()
                                        Swal.close();
                                        vm.openAlertDialog('La postulación se ha enviado exitosamente a la compañía BCI.', 'btn-success')                                        
                                    }
                                    )
                                    .catch
                                    (
                                        error =>
                                        {
                                            console.log(error)
                                              Swal.close();
                                            vm.dialogRef.close()
                                            vm.openAlertDialog('Ha ocurrido un error al cambiar el estado de la postulacion', 'btn-danger')
                                        }
                                    )                 
                        })
                        .catch(error =>
                            {
                                if(error.status==424){
                                    Swal.close();
                                    vm.dialogRef.close()
                                    vm.openAlertDialog('La postulación falló, ya que el envío a compañía no tiene archivos adjuntos', 'btn-danger')
                            
                                }else{
                                    Swal.close();
                                    vm.dialogRef.close()
                                    vm.openAlertDialog('Ha ocurrido un error al enviar la notificación de envío a la compañía', 'btn-danger')
                                 
                                }
                               
                            }) 
                */  
                }else{
                    vm.postulacionesSaludService.envioCompaniaVidaCamara(idPostulacion).then(
                        () =>{
                            vm.postulacionesSaludService.cambiarEstadoPostulacion(idPostulacion, "ENVIADO A COMPANIA",idUsuarioSesion).then                 (
                                () =>
                                { 
                                    vm.data.recarga = true
                                    vm.dialogRef.close()
                                    Swal.close();
                                    vm.openAlertDialog('La postulación se ha enviado exitosamente a la compañía VIDA CAMARA.', 'btn-success')                                        
                                }
                                )
                                .catch
                                (
                                    error =>
                                    {
                                        console.log(error)
                                          Swal.close();
                                        vm.dialogRef.close()
                                        vm.openAlertDialog('Ha ocurrido un error al cambiar el estado de la postulacion', 'btn-danger')
                                    }
                                )                 
                    })
                    .catch(error =>
                        {
                            if(error.status==424){
                                Swal.close();
                                vm.dialogRef.close()
                                vm.openAlertDialog('La postulación falló, ya que el envío a compañía no tiene archivos adjuntos', 'btn-danger')
                        
                            }else{
                                Swal.close();
                                vm.dialogRef.close()
                                vm.openAlertDialog('Ha ocurrido un error al enviar la notificación de envío a la compañía', 'btn-danger')
                             
                            }
                           
                        })   

                }                      
            }
                           
        })
    }
   
    onEditarClick(): void
    {
        this.data.deshabilitado = false
        this.data.presionaEditar = true

    }

    onCancelarClick(): void { this.dialogRef.close() }

    onDescargarArchivoClick(): void
    {
        this.data.archivos.forEach( archivo => {

            const byteCharacters = atob(archivo.archivo.split(',')[1])
            const byteNumbers = new Array(byteCharacters.length)

            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i)
            }

            const byteArray = new Uint8Array(byteNumbers)
            const blob = new Blob([byteArray], {type: archivo.extension})

            var fileURL = URL.createObjectURL(blob)
            window.open(fileURL)
        })
    }

 

    onDescargarArchivosClick(postulacionId: any)
    {
        let vm = this
     
        vm.postulacionesSaludService.traeArchivos(postulacionId).then
        (
            (archivos: any) =>
            {                
                archivos.forEach( archivo => {
                    if(archivo.archivoExterno){
                        var fileURL=`${archivo.url}`       
                    }else{
                        var fileURL=`${environment.urlBlob}/${archivo.url}`       
                    }
                          
                    window.open(fileURL);
                })  
               
            }
        )
        .catch
        (
            error =>
            {
                console.log(error)
                vm.openAlertDialog('Ha ocurrido un error para visualizar el archivo.', 'btn-danger')
            }
        )
    }

    onGuardarClick(idPostulacion: any, idCarga: any,idUsuario:any): void
    {


      Swal.fire({
        allowOutsideClick:false,
        icon:'info',
        text:'Cargando...'
      });
      Swal.showLoading();

        let vm = this

        this.evaluaMontoReembolso()

        let fecha = this.data.fechaDocumento.split('-')
        let fechaFormateada = fecha[2] + '-' + fecha[1] + '-' + fecha[0]
        if(vm.data.montoCopago == 0){
            vm.openAlertDialog('El Monto Copago no debe ser 0 para guardar el Reembolso', 'btn-danger')
            vm.dialogRef.close()
            Swal.close();
            return
        }
        let fechaIngresada = new Date(this.data.fechaDocumento + 'T00:00')

        let fechaMinima = new Date()
        fechaMinima.setDate(fechaMinima.getDate() - this.diasDiferencia1)
        if(fechaIngresada < fechaMinima || fechaIngresada > new Date())
        {
            this.openAlertDialog('La Fecha del Documento supera la vigencia de 180 dias o excede la fecha actual. Favor revisar.', 'btn-danger')
            
            Swal.close();
            return
        }

        let reembolso: any =
        {
            tipoReembolso: this.data.tipoReembolso,
            categoria: this.data.reembolsoCategoria,
            subcategoria: this.data.reembolsoSubcategoria,
            prevision: this.data.prevision,
            nDocumento: this.data.nDocumento,
            nBoleta: this.data.nBoleta,
            rutPrestador: this.data.rutPrestador,
            montoCopago: this.data.montoCopago,
            tipoDocumento: this.data.tipoDocumento,
            montoReembolso: Math.round(this.data.montoReembolso),
            fechaDocumento: fechaFormateada,
            archivo:vm.data.archivo,
            observacion:vm.data.observacion
        }

       

        this.reembolsosService.traeMontoDisponibleSubCategoria(this.data.beneficiario.id, !this.data.carga,
        this.data.reembolsoSubcategoria,this.data.idPostulacion).then
        (
            montoDisponible =>
            {
                console.log(montoDisponible)

                if(montoDisponible == 0)
                {
                    Swal.close();
                    vm.openAlertDialog('Usted ya utilizó el cupo anual que tiene asignado para este tipo de reembolso por lo que no puede ingresar solicitud.', 'btn-danger')
                    return
                }

                if(vm.data.montoReembolso > montoDisponible) { vm.data.montoReembolso = montoDisponible }

                vm.postulacionesSaludService.editaPostulacionReembolso(idPostulacion, idCarga, reembolso,idUsuario).then
                (
                    () =>
                    {
                        vm.data.recarga = true
                        vm.dialogRef.close()
                        Swal.close();
                        vm.openAlertDialog('La postulación se ha guardado exitosamente.', 'btn-success')
                    }
                )
                .catch
                (
                    error =>
                    {
                        vm.dialogRef.close()
                        console.log(error)

                        if(error.status == 403)
                        {
                            vm.openAlertDialog('Ya se tiene ingresada una solicitud con el mismo N. Documento, Tipo de Documento y Rut de Prestador.', 'btn-danger')
                            Swal.close();
                            return
                        }
                        else {
                          Swal.close();
                          vm.openAlertDialog('Ha ocurrido un error al guardar el Reembolso!!', 'btn-danger') }
                    }
                )
            }
        )
        .catch
        (
            error =>
            {
                console.log(error)

                if(error.status != 404)
                {
                    Swal.close();
                    vm.openAlertDialog('Usted ya utilizó el cupo anual que tiene asignado para este tipo de reembolso por lo que no puede ingresar solicitud.', 'btn-danger')
                    return
                }
                else{
                    Swal.close();
                    vm.openAlertDialog('Ha ocurrido un error interno.', 'btn-danger')
                    return
                }


            }
        )
    }

    openAlertDialog(mensaje: string, clase: string)
    {
        this.dialog.open(AlertDialogComponent, {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }

    seleccionaTipo()
    {
        let vm = this

        this.data.categorias = []
        this.data.reembolsoCategoria = null

        this.reembolsosService.traeCategorias(this.data.tipoReembolso).then
        (
            categorias =>
            {
                vm.data.categorias = categorias

                vm.data.subcategorias = []
                vm.data.reembolsoSubcategoria = null
            }
        )
        .catch ( error => console.log(error) )
    }

    seleccionaCategoria()
    {
        let vm = this

        this.data.subcategorias = []
        this.data.reembolsoSubcategoria = null

        this.reembolsosService.traeSubCategorias(this.data.reembolsoCategoria).then
        (
            (subcategorias: any) => { vm.data.subcategorias = subcategorias }
        )
        .catch ( error => console.log(error) )
    }

    evaluaMontoReembolso()
    {
        let subcategoria: any

        this.data.subcategorias.forEach( (val: any) => {
           console.log(val.id);
           console.log(this.data.reembolsoSubcategoria);
            if(val.id == this.data.reembolsoSubcategoria) subcategoria = val
        } )

        if(this.data.tipoDocumento == 'BONO')
        {
            this.data.montoReembolso = this.data.montoCopago * subcategoria.porcentajeBono
        }
        else if(this.data.tipoDocumento == 'REEMBOLSO')
        {
            this.data.montoReembolso = this.data.montoCopago * subcategoria.porcentajeReembolso
        }
        else { this.data.montoReembolso = this.data.montoCopago * subcategoria.porcentajeBoleta }

        if(this.data.montoReembolso > subcategoria.topeEvento) { this.data.montoReembolso = subcategoria.topeEvento }
    }

    sumaArchivo() {
        if (this.data.cantidadArchivos <= 6) {

            this.data.cantidadArchivos = this.data.cantidadArchivos + 1
        }
    }

    seleccionaArchivo(event: any, numero: number) {
        if (event.target.files.length > 0) {
            console.log(event.target.files[0].type)

            let vm = this
            let reader = new FileReader()
            this.data.archivo[numero] = { url: "", archivo: reader.result, extension: event.target.files[0].type, size: event.target.files[0].size }
            reader.readAsDataURL(event.target.files[0])

            reader.onload = function () {
                vm.data.archivo[numero] = { url: "", archivo: reader.result, extension: event.target.files[0].type, size: event.target.files[0].size }
            }
        }
    }

    restaArchivo() {
        this.data.cantidadArchivos = this.data.cantidadArchivos - 1
        this.data.archivo.splice(this.data.cantidadArchivos, 1);
    }
}
